import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { CardSection, CardWrapper } from 'foundations-components/transitional/components/Card';
import { H5 } from 'foundations-components/transitional/components/H5';
import { FREE_LIMITS_WITH_CONTENT } from '../constants/FreeLimits';
import LimitCardProgressBar from './LimitCardProgressBar';
import { getLimitCardTanslation } from './limitCardUtils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const LimitCard = ({
  limit
}) => {
  var _limit$limit;
  const {
    limitName,
    nextTierLimit
  } = limit;
  if (!FREE_LIMITS_WITH_CONTENT.includes(limitName) || limit.usage == null || ((_limit$limit = limit.limit) !== null && _limit$limit !== void 0 ? _limit$limit : 0) <= 0) return null;
  const headingKey = getLimitCardTanslation(limitName, 'heading');
  const descriptionKey = getLimitCardTanslation(limitName, 'description');
  const nextTierLimitKey = getLimitCardTanslation(limitName, 'upgrade');
  return /*#__PURE__*/_jsx(CardWrapper, {
    children: /*#__PURE__*/_jsx(CardSection, {
      padding: "1000",
      children: /*#__PURE__*/_jsxs(Flex, {
        flexDirection: "column",
        flex: 1,
        children: [headingKey && /*#__PURE__*/_jsx(H5, {
          marginBlockEnd: "200",
          "aria-level": 3,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: headingKey
          })
        }), /*#__PURE__*/_jsx(LimitCardProgressBar, {
          limit: limit
        }), /*#__PURE__*/_jsx(Text, {
          marginBlockEnd: "400",
          children: descriptionKey && /*#__PURE__*/_jsx(FormattedMessage, {
            message: descriptionKey
          })
        }), nextTierLimit && nextTierLimitKey && /*#__PURE__*/_jsx(Text, {
          as: "small",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: nextTierLimitKey,
            options: {
              newLimit: nextTierLimit
            }
          })
        })]
      })
    })
  });
};
export default LimitCard;